import { selectSelectedSchool } from "app/modules/schools/selectors";
import React from "react";
import { useSelector } from "react-redux";
import { ReactComponent as AppLogo } from "assets/media/images/logo.svg";

import { Box, Stack, Typography, styled, useMediaQuery } from "@mui/material";
import { THEME } from "app/config/constants";

const InstituteBrand = ({ onClick }) => {
  const selectedSchool = useSelector(selectSelectedSchool);
  const isMobile = useMediaQuery("(max-width: 768px)");
  const showHamburger = useMediaQuery("(min-width: 769px)");
  
  return selectedSchool ? (
    <StyledWrapper direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1, md: 1.5 }}>
      {/* Hamburger Menu - Show on tablet and desktop, hide on mobile */}
      {showHamburger && (
        <Box
          onClick={onClick}
          sx={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            padding: { xs: "4px", sm: "6px", md: "8px" },
            transition: "all 0.2s ease",
            "&:hover": {
              backgroundColor: "rgba(8, 76, 132, 0.05)",
              borderRadius: "8px",
            },
          }}
        >
          <div className="hamburger">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </Box>
      )}

      {/* School Logo */}
      <Box
        sx={{
          flexShrink: 0,
          borderRadius: "12px",
          overflow: "hidden",
          border: "2px solid rgba(60, 110, 239, 0.2)",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
          transition: "all 0.3s ease",
          "&:hover": {
            transform: "scale(1.05)",
            boxShadow: "0 4px 12px rgba(60, 110, 239, 0.2)",
          },
        }}
      >
        <img
          src={selectedSchool?.schoolLogo || "/image-placeholder.jpeg"}
          alt="School Logo"
          className="school-logo"
        />
      </Box>

      {/* School Details */}
      {!isMobile && (
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography
            className="school_name_text"
            title={selectedSchool?.schoolName}
            sx={{
              fontSize: {
                xs: "12px",
                sm: "14px",
                md: "16px",
                lg: "18px",
              },
            }}
          >
            {selectedSchool?.schoolName}
          </Typography>
          {!isMobile && (
            <Typography
              className="address_text"
              title={`${selectedSchool?.schoolAddress?.address ?? ""}, ${
                selectedSchool?.schoolAddress?.dist ?? ""
              }, ${selectedSchool?.schoolAddress?.state ?? ""} ${
                selectedSchool?.schoolAddress?.pinCode ?? ""
              }`}
              sx={{
                fontSize: {
                  sm: "12px",
                  md: "13px",
                  lg: "14px",
                },
              }}
            >
              {`${selectedSchool?.schoolAddress?.dist ?? ""}, ${
                selectedSchool?.schoolAddress?.state ?? ""
              } ${selectedSchool?.schoolAddress?.pinCode ?? ""}`}
            </Typography>
          )}
        </Box>
      )}
    </StyledWrapper>
  ) : (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <AppLogo />
    </Box>
  );
};

export default InstituteBrand;

const StyledWrapper = styled(Stack)`
  width: 100%;
  max-width: 100%;

  .hamburger {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
    width: 24px;
    height: 18px;

    @media (max-width: 768px) {
      width: 20px;
      height: 16px;
      gap: 3px;
    }
  }

  .hamburger span {
    display: block;
    background-color: #084c84;
    border-radius: 10px;
    height: 3px;
    width: 100%;
    transition: all 0.3s ease;

    @media (max-width: 768px) {
      height: 2.5px;
    }
  }

  &:hover .hamburger span {
    background-color: #0a5fa5;
  }

  .school-logo {
    width: 46px;
    height: 46px;
    object-fit: cover;
    display: block;
    padding: 2px;
    border-radius: 12px;

    @media (max-width: 1024px) {
      width: 42px;
      height: 42px;
    }

    @media (max-width: 768px) {
      width: 36px;
      height: 36px;
    }
  }

  .school_name_text {
    color: ${THEME.primary};
    font-weight: 600;
    line-height: 1.3;
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    margin: 0;
  }

  .address_text {
    color: #5a7184;
    font-weight: 500;
    line-height: 1.3;
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    margin: 0;
    margin-top: 2px;
  }
`;
